var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var AssetItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  & + & {\n    margin-top: ", ";\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  & + & {\n    margin-top: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.md;
});
export var AssetItemName = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: 34px;\n  flex: 1;\n"], ["\n  padding-left: 34px;\n  flex: 1;\n"])));
export var AssetItemColor = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 4px;\n  left: 0;\n  width: 18px;\n  height: 18px;\n  margin-right: ", ";\n  background: ", ";\n  border-radius: 50%;\n"], ["\n  position: absolute;\n  top: 4px;\n  left: 0;\n  width: 18px;\n  height: 18px;\n  margin-right: ", ";\n  background: ", ";\n  border-radius: 50%;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.spacing.md;
}, function (_a) {
  var color = _a.color;
  return color;
});
var templateObject_1, templateObject_2, templateObject_3;